import { useState } from 'react';

export const useTotalData = () => {
  const [totalData, setTotalData] = useState<ITotalData>({
    bagAPrice: '',
    bagAPricePerTon: '',
    bagAId: '',
    bagBPrice: '',
    bagBPricePerTon: '',
    bagBId: '',
    resPrice: '',
    resPricePerTon: '',
    resProfit: undefined,
    resId: '',
  });

  return { totalData, setTotalData };
};

interface ITotalData {
  bagAPrice: string | number;
  bagAPricePerTon: string | number;
  bagAId: string | number;
  bagBPrice: string | number;
  bagBPricePerTon: string | number;
  bagBId: string | number;
  resPrice: string | number;
  resPricePerTon: string | number;
  resId: string | number;
  resProfit?: number;
}
